<template>
	<div class="header-fragment">
		<div class="user">{{ user.name }}</div>
		<div class="logout" style="cursor: pointer;" @click="logout">Log out</div>
	</div>
</template>

<script>
	export default {
		name: 'HeaderFragment',
		computed: {
			user() {
				return this.$store.getters.user;
			}
		},
		methods: {
			logout() {
				this.$store.commit('auth', null);
				localStorage.removeItem('auth');

				this.$router.replace({
					name: 'login'
				});
			}
		},
	}
</script>

<style lang="scss" scoped>
	.header-fragment {
		/* background: #00202f url('/images/logo.png') no-repeat 20px center; */
		background-color: white;
		text-align: right;
		border-bottom: 4px solid #f0f0f0;

		> div {
			display: inline-block;
			height: 64px;
			line-height: 64px;
			color: white;
			font-size: 16px;
			margin-right: 20px;
		}
	}
</style>